// @flow

import { selectRawProductsArray } from '@gandi/cart';

import type { Product } from '@gandi/cart';

import { useAppSelector } from 'src/hooks/useAppSelector';

export function useOwnershipDisclaimer(): {
  hasTransfer?: Product,
  hasCloud?: Product,
  hasRenew?: Product,
  hasChangeOwner?: Product,
} {
  const products = useAppSelector(selectRawProductsArray);

  const hasTransfer = products.find(
    ({ process, productType }) =>
      productType === 'domain' && process === 'transfer',
  );
  const hasCloud = products.find(({ productType }) => productType === 'cloud');

  const hasRenew = products.find(({ process }) => process === 'renew');

  const hasChangeOwner = products.find(
    ({ payload }) => payload?.change_owner === true,
  );

  return {
    hasTransfer,
    hasCloud,
    hasRenew,
    hasChangeOwner,
  };
}
